<script setup lang="ts">
import type { IArticleCategory } from '../model/article.interfaces';
import type { MaterialAITagDTO } from '~/shared/api/client/tags/ai-tags.dto';
// import { CLIENT_TAG_AI_URL } from '~/shared/api/client/news/news.const';

const props = defineProps<{
  /** Корневой тег (категория) и новостные теги (sectors). Выглядят одинаково. */
  categories?: IArticleCategory[];
  /** AI-теги. Выводятся со значком CRE AI. */
  aiTags?: MaterialAITagDTO[];
}>();
</script>

<template>
  <div :class="$style.categories">
    <NuxtLink
      v-for="(item, key) in props.categories"
      :key="`articleCategories_${key}`"
      :class="$style.categories__link"
      :to="item.link"
    >
      {{ item.title }}
    </NuxtLink>
    <!-- AI-теги временно скрыты
    <NuxtLink
      v-for="tag in props.aiTags"
      :key="`articleAiTag_${tag.id}`"
      :class="[$style.categories__link, $style.categories__link_ai]"
      :to="`${CLIENT_TAG_AI_URL}${tag.id}`"
    >
      <span>{{ tag.display_name || tag.name }}</span>
      <Icon :class="$style.categories__badge" name="my-icon:i-ai" />
    </NuxtLink>
    -->
  </div>
</template>

<style module lang="scss">
.categories {
  display: flex;
  flex-flow: row wrap;
  column-gap: var(--space-2-5x);
  row-gap: var(--space-1x);
  align-items: center;

  &__link {
    @include text_caption1_caps;
    color: var(--color-red-2);
    text-decoration: none;

    &_ai {
      display: inline-flex;
      align-items: flex-start;
    }
  }

  &__badge {
    width: 8px;
    height: 8px;
    margin-left: 2px;
    flex-shrink: 0;
    color: var(--color-gray-text);
  }
}

@media (max-width: 479px) {
  .categories {
    justify-content: center;
  }
}
</style>
